import { COMPONENTS } from '../../../components/components.registry';
import { NextQueriesConfig } from '../../../models';

export const DEFAULT_NEXT_QUERIES_CONFIG: NextQueriesConfig = {
  components: {
    header: null,
    footer: null,
    nextQuery: {
      header: null,
      grid: COMPONENTS.PURE.DefaultGrid,
      result: COMPONENTS.SMART.ConfigurableResult,
      footer: COMPONENTS.PURE.NextQueryViewAll,
      beforeResults: null,
      afterResults: null
    }
  },
  facetsToApply: ['hierarchical_category'],
  filterBySessionQueryHistory: true,
  gridColumns: 4,
  max: Number.MAX_SAFE_INTEGER,
  maxWhenNotReachingTrigger: 4,
  pageFrequency: 2,
  perLoad: 2,
  results: 4,
  withResults: true
};
